import _ from 'underscore';

function toArrayFilter() {
  return function (obj) {
    /*
    * https://github.com/angular/angular.js/issues/1286#issuecomment-14303275
    */
    if (!(obj instanceof Object)) return obj;
    return _.map(obj, function (val, key) {

      return Object.defineProperty(val, '$key', { __proto__: null, value: key });

    });
  }
}

export default toArrayFilter;
